export const ETA_HARD_LOCK_CODE = "ETA_HARD_LOCK";
export const ETA_HARD_LOCK_EVENT = "eta-hard-lock";

export type EtaHardLockEventDetail = {
  orderId: string;
  orderNo?: string;
  eta?: string;
};

export function dispatchEtaHardLockEvent(detail: EtaHardLockEventDetail): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(ETA_HARD_LOCK_EVENT, {
      detail,
    }),
  );
}

export function isEtaHardLockError(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: unknown } })
    ?.response;
  if (response?.status !== 423) {
    return false;
  }
  const data = response.data;
  if (data && typeof data === "object" && !Array.isArray(data)) {
    return (data as { code?: string }).code === ETA_HARD_LOCK_CODE;
  }
  return false;
}

export function getEtaHardLockDetailFromError(
  error: unknown,
): EtaHardLockEventDetail | null {
  if (!isEtaHardLockError(error)) {
    return null;
  }
  const data = (error as { response: { data: Record<string, unknown> } })
    .response.data;
  const orderId = data.orderId != null ? String(data.orderId) : "";
  if (!orderId) {
    return null;
  }
  return {
    orderId,
    orderNo: data.orderNo != null ? String(data.orderNo) : undefined,
    eta: data.eta != null ? String(data.eta) : undefined,
  };
}
